// Telefona KURULU ikilinin sürümü (8.6 · D-667).
//
// OTA ile gelen kod değil: `runtimeVersion` derleme anında app.json'daki
// `version`dan sabitlenir (policy: appVersion) ve OTA onu değiştirmez. Böylece
// OTA'yla gelen bu kod, üzerinde çalıştığı ikilinin eskidiğini bilebilir.
// Geliştirme ve testte yoktur (null): o zaman kart hiç çıkmaz.
import * as Updates from 'expo-updates';

export function installedAppVersion(): string | null {
  const value = Updates.runtimeVersion;
  return typeof value === 'string' && /^\d+(\.\d+){1,3}$/.test(value) ? value : null;
}
